//--------------------
// calc current skill
//--------------------
export default function calcCurrentSkill(parm) {
  // console.log('---------------------------------')
  // console.log('IN calcCurrentSkill')

  // use parent_cur if provided - otherwise use base
  const base =
    parm.parent_cur !== undefined && parm.parent_cur !== null
      ? Number(parm.parent_cur)
      : Number(parm.base) || 0
  const ticks = Number(parm.ticks) || 0
  const training = Number(parm.training) || 0
  const adjs_tot = Number(parm.adjs_tot) || 0

  // console.log('base = ', base)
  // console.log('ticks = ', ticks)
  // console.log('training = ', training)
  // console.log('adjs_tot = ', adjs_tot)

  let cur = base + ticks + training + adjs_tot

  // theoretically the neg adjs could take cur below zero
  if (cur < 0) {
    cur = 0
  }
  return Math.floor(cur)
}
